// import React from "react";
// // import PropTypes from "prop-types";
// import { getImageByService } from "../../../assets/themes/images";
// // import { callNumber } from "../../../../utils/call";
// import { FaPhone } from "react-icons/fa";

// const InfoVehicles = ({
//   headerText,
//   driverAvatarUrl,
//   driverName,
//   driverLastName,
//   vehicle,
//   vehicleNumber,
//   vehicleModel,
//   vehicleColor,
//   showPhoneNumber,
//   driverPhoneNo,
// }) => {
//   const callPartner = (phoneNumber) => {
//     // callNumber(phoneNumber);
//   };
// console.log("vehicle",vehicle)
//   return (
//     <div className="p-4 rounded-lg shadow-md bg-white">
//       <h2 className="text-lg font-semibold text-gray-800">{headerText}</h2>

//       <div className="flex items-center mt-4">
//         <img
//           src={driverAvatarUrl?.trim() ? driverAvatarUrl : "dummyDriverImageURL"}
//           alt="Driver"
//           className="w-12 h-12 rounded-full border border-gray-300 object-cover"
//         />
//         <div className="ml-4">
//           <p className="text-sm font-medium text-gray-900">
//             {driverName}
//           </p>
//         </div>
//       </div>

//       <div className="flex items-center mt-4">
//         <img
//           src={getImageByService(vehicle)}
//           alt="Vehicle"
//           className="w-16 h-16 object-contain"
//         />
//         <div className="ml-4">
//           <p className="text-sm font-semibold text-gray-900">
//             {vehicleNumber || "..."}
//           </p>
//           <p className="text-xs text-gray-600">
//             {vehicleModel || "..."} • <span className="text-blue-500">{vehicleColor}</span>
//           </p>
//         </div>
//       </div>

//       {showPhoneNumber && (
//         <button
//           className="mt-4 flex items-center p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//           onClick={() => callPartner(driverPhoneNo)}
//         >
//           <FaPhone className="mr-2" /> Call Driver
//         </button>
//       )}
//     </div>
//   );
// };

// // InfoVehicle.propTypes = {
// //   headerText: PropTypes.string.isRequired,
// //   driverAvatarUrl: PropTypes.string,
// //   driverFirstName: PropTypes.string,
// //   driverLastName: PropTypes.string,
// //   vehicle: PropTypes.string.isRequired,
// //   vehicleNumber: PropTypes.string,
// //   vehicleModel: PropTypes.string,
// //   vehicleColor: PropTypes.string,
// //   showPhoneNumber: PropTypes.bool,
// //   driverPhoneNo: PropTypes.string,
// // };

// export default InfoVehicles;

import React from "react";
import { getImageByService } from "../../../assets/themes/images";
import { FaPhone } from "react-icons/fa";
import {driverDummyImage }from '../../../assets/themes/images'

const InfoVehicles = ({
  headerText,
  driverAvatarUrl,
  driverName,
  vehicle,
  vehicleNumber,
  vehicleModel,
  vehicleColor,
  showPhoneNumber,
  driverPhoneNo,
}) => {
  const callPartner = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
  };
  return (
    <div className="p-4 rounded-lg shadow-md bg-white">
    <h2 className="text-lg font-semibold text-gray-800">{headerText}</h2>
  
    {/* Row Layout */}
    <div className="flex flex-row items-center justify-between mt-4">
      {/* Driver & Vehicle Info Combined */}
      <div className="flex items-center">
        {/* Driver Info */}
        <img
          src={driverAvatarUrl?.trim() ? driverAvatarUrl : driverDummyImage}
          alt="driver img"
          className="w-12 h-12 rounded-full border border-gray-300 object-cover"
        />
       
  
        {/* Vehicle Info (No Gap) */}
        <div className="flex items-center ml-0">
          <img
            src={getImageByService(vehicle)}
            alt="Vehicle"
            className="w-16 h-16 object-contain"
          />
          <div className="ml-2">
          <p className="ml-4 text-sm font-medium text-gray-900">{driverName}</p>
            <p className="text-sm font-semibold text-gray-900">{vehicleNumber || "..."}</p>
            <p className="text-xs text-gray-600">
              {vehicleModel || "..."} • <span className="text-blue-500">{vehicleColor}</span>
            </p>
          </div>
        </div>
      </div>
  
      {/* Call Button */}
      {showPhoneNumber && (
        <button
          className="flex items-center p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          onClick={() => callPartner(driverPhoneNo)}
        >
         <FaPhone className="transform scale-x-[-1]" />
        </button>
      )}
    </div>
  </div>
  
  );
};

export default InfoVehicles;

